<template>
  <div></div>
</template>

<script>
export default {
  name: 'Config.vue',
};
</script>

<style scoped>

</style>
